export enum headerActionType {
  SET_TITLE = 'SET_TITLE',
  RESET_TITLE = 'RESET_TITLE',
}
